import StickyAlertProps, {
  StickyAlertPropsSchema,
} from '@/modules/alerts/models/sticky-alert-props';

export const BASIC_STICKY_ALERT_TYPE = {
  SUCCESS: 'SUCCESS',
  WARNING: 'WARNING',
  ERROR: 'ERROR',
} as const;

type ObjectValues<T> = T[keyof T];

export type BasicStickyAlertType = ObjectValues<typeof BASIC_STICKY_ALERT_TYPE>;

export interface BasicStickyAlertOptions {
  subMessage?: string;

  timeoutMs?: number;
}

/**
 * This is an interface because `defineProps` only works with interfaces.
 */
export interface BasicStickyAlertPropsSchema extends StickyAlertPropsSchema {
  type: BasicStickyAlertType;

  message: string;

  options?: BasicStickyAlertOptions;
}

export default class BasicStickyAlertProps extends StickyAlertProps
  implements BasicStickyAlertPropsSchema {
  type: BasicStickyAlertType;

  message: string;

  options?: BasicStickyAlertOptions;

  constructor(type: BasicStickyAlertType, message: string, options: BasicStickyAlertOptions) {
    super();
    this.type = type;
    this.message = message;
    this.options = options;
  }
}
